export default [
  {
    path: '/login',
    component: () => import('@/views/login/Index'),
    children: [
      {
        name: 'Login',
        path: '',
        component: () => import('@/views/login/Login'),
        meta: {
          routeReleasedForLite: true
        }
      },
      {
        name: 'Login OpenID Connect COPEL',
        path: 'oidc-copel',
        component: () => import('@/views/login/OidcCopel'),
        meta: {
          routeReleasedForLite: true
        }
      }
    ]
  }
];
